import _Marquee from "@kibt/meta-ui/es/marquee";
import { defineComponent } from '@vue/composition-api';
import MyButton from './my-button.vue';
export default defineComponent({
  components: {
    MMarquee: _Marquee,
    MyButton: MyButton
  },
  props: {
    displayedUser: {
      type: Object,
      required: true
    }
  },
  emits: ['show-user-popup'],
  setup: function setup(props, ctx) {
    return {};
  }
});